// extracted by mini-css-extract-plugin
export default {"root":"RescheduleDetails_root__ZsC-s","scheduleFieldGroup":"RescheduleDetails_scheduleFieldGroup__fVcAR"};